<template>
    <div class="main-con el-main">
        <router-view />
    </div>
</template>

<script>
    export default {
        name: "BranchUser"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/branchoffice/BranchUser.vue